import { render, staticRenderFns } from "./GenericWrapper.vue?vue&type=template&id=36ad7d0a&lang=html"
import script from "./GenericWrapper.vue?vue&type=script&lang=js"
export * from "./GenericWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../modules/tukes/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports